import { styled } from '@linaria/react';

import { colors, fonts, layout, space } from '../../theme/tokens';

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[4]};
  min-height: 76px;
  padding: ${space[4]} ${space[5]};
  border: 1px solid ${colors.borderGrey};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &[data-selected='true'] {
    border-color: ${colors.fontPrimary};
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const OptionLabelText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
`;

export const OptionDescription = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
`;

export const RadioInput = styled.input`
  appearance: none;
  margin: 0;
  width: 18px;
  height: 18px;
  border: 1px solid ${colors.borderGrey};
  border-radius: 50%;
  cursor: inherit;
  background: ${colors.white};
  position: relative;
  flex-shrink: 0;

  &:checked {
    border-color: ${colors.fontPrimary};
    background: ${colors.fontPrimary};
    box-shadow: inset 0 0 0 3px ${colors.white};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
